// The free plan's daily ABSITE question allowance, as signed-out pages state it
// (the QLink drawer's offer, /login's line for the ABSITE practice entry). The
// server enforces the plan's own questionsPerDay; signed-in pages read that
// (qlink-free-allowance.js, the daily-limit card) instead of this number.
export const FREE_DAILY_ABSITE_QUESTIONS = 10;
